<script type="text/ecmascript-6">
    import AxAttributesBase from './AxAttributesBase';

    export default {
        extends: AxAttributesBase,
        props: {
            'variants': Array,
        },
    }
</script>

<template>
    <div>
        <template v-for="groupedVariants in variants">
            <template v-for="(variant, key) in groupedVariants">
                <ax-attributes-variant-color
                        :policies="policies"
                        :variantColor="variant.color"
                        v-if="key === 0"
                ></ax-attributes-variant-color>
                <ax-attributes-variant-size
                        :policies="policies"
                        :variant="variant"
                ></ax-attributes-variant-size>
            </template>
        </template>
    </div>
</template>